import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AccountService} from "../auth/account-service.service";
import {OidcSecurityService, UserDataResult} from "angular-auth-oidc-client";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {GetRepairCentreInformationService} from "../services/get-repair-centre-information.service";
import {Observable} from "rxjs";
import {VinSearchComponent} from "../repair-centre/vin-search/vin-search.component";
import {isGlobalEmployee} from "../auth/is-global-employee";
import {RepairCentreDto} from "../auto-generated-server-dtos/repair-centre-information/models/repair-centre-dto";
import {GetGlobalViewModelService} from "../services/get-global-view-model.service";
import {GlobalViewModelDto} from "../auto-generated-server-dtos/global-view-model/repair-centre/global-view-model-dto";
import {environment} from "../../environments/environment";

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit {
  isExpanded = false;
  public userFullName: string = '';
  public name: string = '';
  userData$: Observable<UserDataResult>;
  public globalViewModelDto?: GlobalViewModelDto;
  public isGlobalEmployee = false;
  public isClaimsManagerOrAssistantClaimsManager = false;


  constructor(
    private accountService: AccountService,
    private oidcSecurityService: OidcSecurityService,
    private ngbModal: NgbModal,
    private getGlobalViewModelService: GetGlobalViewModelService,
    private router: Router
  ) {
    this.userData$ = this.oidcSecurityService.userData$;
    this.userData$.subscribe((userData) => {
      if(!userData || !userData.userData)
      {
        return;
      }

      if (userData.userData.FirstName && userData.userData.LastName) {
        this.name = userData.userData.FirstName + ' ' + userData.userData.LastName;
      }

      this.isGlobalEmployee = userData.userData.UserType === 'GlobalWarrantyEmployee';
      this.isClaimsManagerOrAssistantClaimsManager = userData.userData.Roles && (userData.userData.Roles.includes('GlobalWarrantyClaimsManager') || userData.userData.Roles.includes('GlobalWarrantyAssistantClaimsManager'));

      if(!this.isGlobalEmployee && userData.userData.RepairCentreId) {
        this.getGlobalViewModelService.getGlobalViewModel().subscribe((globalViewModelDto) => {
          this.globalViewModelDto = globalViewModelDto;
        });
      }
    });
  }

  newClaim() {
    this.ngbModal.open(VinSearchComponent, {size: 'lg'});
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  ngOnInit(): void {
  }

  logout() {
    this.oidcSecurityService.logoff().subscribe();
  }

  protected readonly environment = environment;
}
